import { css, Interpolation, Theme } from '@emotion/react'
import { avatarClasses, buttonClasses } from '@mui/material'

export const container: Interpolation<Theme> = (theme) => css`
  min-height: 100%;
  width: 100%;
  padding: ${theme.spacing(3)};
`

export const header: Interpolation<Theme> = (theme) => css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: ${theme.spacing(1, 0, 3)};
`

export const title: Interpolation<Theme> = css`
  font-weight: 700;
`

export const exportButton: Interpolation<Theme> = css`
  padding-bottom: 12px;

  > [class*='MuiButton-startIcon'] {
    margin-right: 0;
    margin-bottom: 2px;
    svg {
      width: 20px !important;
      height: 20px !important;
    }
  }
`

export const buttonGroup: Interpolation<Theme> = (theme) => css`
  flex-wrap: wrap;
  column-gap: ${theme.spacing(1.5)};

  .${buttonClasses.root} {
    border: none;
    min-width: 0;
  }
`

export const roleFilterButton =
  (isActive: boolean): Interpolation<Theme> =>
  (theme) =>
    css`
      padding: 0;
      color: ${theme.colors.typographyThree};
      font-size: 16px;
      line-height: 20px;

      ${isActive &&
      css`
        color: ${theme.colors.typographyTwo};
      `}

      :hover {
        background-color: transparent;
        color: ${theme.colors.typographyThreeHover};
      }
    `

export const filterInputs: Interpolation<Theme> = (theme) => css`
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  gap: ${theme.spacing(2)};

  ${theme.breakpoints.down(650)} {
    > div {
      width: 100%;
    }
  }
`

export const filter: Interpolation<Theme> = css`
  width: 205px;
`

export const tableWrapper: Interpolation<Theme> = (theme) => css`
  .table-header {
    min-height: 60px;
  }

  .table-row {
    min-height: 84px;
    padding: ${theme.spacing(0.75, 1.5)};
  }

  .table-row .actions {
    box-sizing: border-box;
    height: 24px;
    display: flex;
    gap: 12px;
    align-items: end;
    transition: all ${theme.transitions.duration.standard}ms ${theme.transitions.easing.easeInOut};
    overflow: hidden;
  }
  .table-row:not(:hover) .actions {
    height: 0;
  }
`

export const titleWrapper: Interpolation<Theme> = css`
  display: flex;
  flex-direction: column;
`

export const fullNameCell: Interpolation<Theme> = (theme) => css`
  display: flex;
  align-items: center;
  column-gap: ${theme.spacing(1.5)};

  .${avatarClasses.root} {
    width: 28px;
    height: 28px;
  }
`

export const membershipsCell: Interpolation<Theme> = (theme) => css`
  display: flex;
  flex-direction: column;
  row-gap: ${theme.spacing(0.5)};
`

export const activeMembership: Interpolation<Theme> = (theme) => css`
  color: ${theme.colors.green};
`

export const pausedMembership: Interpolation<Theme> = (theme) => css`
  color: ${theme.colors.blue};
`

export const expiredMembership: Interpolation<Theme> = (theme) => css`
  color: ${theme.colors.typographyTwo};
`

export const headerWrapper: Interpolation<Theme> = css`
  justify-content: flex-end;
`

export const toolbarWrapper = (theme: Theme) => css`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: ${theme.spacing(2)};

  margin: ${theme.spacing(2)} 0;
`

export const paginationWrapper: Interpolation<Theme> = (theme) => css`
  ${theme.breakpoints.down(1000)} {
    width: 100%;
    justify-content: right;
  }
`

export const action: Interpolation<Theme> = (theme: Theme) => css`
  width: 36px;
  height: 36px;
  padding: 0;
  border: 1px solid ${theme.colors.backgroundOne};
  border-radius: 10px;
  min-width: 0;

  &.MuiButtonBase-root:hover {
    background: none;
  }
`

export const footer: Interpolation<Theme> = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
